export default {
    ONE_PLACE_PARAM_TIP: 'Укажите габариты и вес одного места (груза). Если груз однотипный, укажите его количество ниже.',
};



// WEBPACK FOOTER //
// ./client/lang/ru/tips.js